export default __webpack_public_path__ + "static/media/bg-image-affiliate.6c4c32fb.png";